module.exports = __webpack_public_path__ + "img/menu_contact.8e4de0a.svg";